import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import MLNotificationBlockUtil from './MLNotificationBlockUtil';

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/*
 * Used to inject MLNotificationBlockUtil as prop to the wrapped component, specially useful in class components.
 * The prop will be called 'notificationBlockUtil'.
 */
export function withMLNotificationBlockUtil(WrappedComponent) {
    function WithMLNotificationBlockUtil(props) {
        const NotificationBlockUtil = MLNotificationBlockUtil()


        return (
            <WrappedComponent
                {...props}
                notificationBlockUtil={NotificationBlockUtil}
            />
        );
    }
    hoistNonReactStatic(WithMLNotificationBlockUtil, WrappedComponent);
    WithMLNotificationBlockUtil.displayName = `WithMLNotificationBlockUtil(${getDisplayName(WrappedComponent)})`;
    return WithMLNotificationBlockUtil;
}